import type { ReactNode } from 'react';

import styles from './Page.module.css';

export type PageHeaderProps = {
  readonly title: ReactNode;
  readonly description?: ReactNode;
  readonly actions?: ReactNode;
  /** Навигация назад — над заголовком, как в мастере агента. */
  readonly backLink?: ReactNode;
};

/** Заголовок страницы: один h1 и один способ расставить действия. */
export function PageHeader({ title, description, actions, backLink }: PageHeaderProps) {
  return (
    <header className={styles['header']}>
      <div className={styles['heading']}>
        {backLink ? <div>{backLink}</div> : null}
        <h1 className={styles['title']}>{title}</h1>
        {description ? <p className={styles['description']}>{description}</p> : null}
      </div>
      {actions ? <div className={styles['headerActions']}>{actions}</div> : null}
    </header>
  );
}
